export default __webpack_public_path__ + "static/media/comon_complaints.b322ace9.png";